<template>
  <div class="hero">

    <b-jumbotron
      :class="{'contactHight' : $route.name == 'contact'}"
      class="splash"
      :style="{
        backgroundImage: `url(${acf.acf.splash})`
      }"
    >

      <!-- Dark overlay -->
      <div class="heroOverlay"></div>

      <!-- =========================================
           TOP BAR
      ========================================== -->

      <div class="topBar">

        <!-- Menu -->
        <div class="menu">

          <b-button
            v-b-toggle.sidebar-no-header
            class="menuButton"
            aria-label="Open navigation"
          >
            <font-awesome-icon
              id="menuOpen"
              class="icon"
              :icon="['fa', 'bars']"
            />
          </b-button>


          <!-- Sidebar -->

          <b-sidebar
            id="sidebar-no-header"
            aria-labelledby="sidebar-no-header-title"
            no-header
            shadow
          >

            <template #default>

              <!-- Sidebar Header -->

              <div class="sidebarHeader">

                <b-img
                  class="sidebarLogo"
                  src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/03/OCS__Sport_Logo_2017_WO.png"
                ></b-img>

                <b-button
                  class="close"
                  v-b-toggle.sidebar-no-header
                  aria-label="Close navigation"
                >
                  <b-icon-X></b-icon-X>
                </b-button>

              </div>


              <!-- Navigation -->

              <nav class="sidebarNavigation">

                <b-nav vertical>

                  <b-nav-item
                    to="/"
                    :class="{ current: id === 4 }"
                    v-b-toggle.sidebar-no-header
                  >
                    <span>01</span>
                    Home
                  </b-nav-item>


                  <b-nav-item
                    to="/tour-management"
                    :class="{ current: id === 201 }"
                    v-b-toggle.sidebar-no-header
                  >
                    <span>02</span>
                    Tour Management
                  </b-nav-item>


                  <b-nav-item
                    to="/venue-management"
                    :class="{ current: id === 158 }"
                    v-b-toggle.sidebar-no-header
                  >
                    <span>03</span>
                    Venue Management
                  </b-nav-item>


                  <b-nav-item
                    to="/about-us"
                    :class="{ current: id === 12 }"
                    v-b-toggle.sidebar-no-header
                  >
                    <span>04</span>
                    About Us
                  </b-nav-item>


                  <b-nav-item
                    to="/case-studies"
                    :class="{ current: id === 1813 }"
                    v-b-toggle.sidebar-no-header
                  >
                    <span>05</span>
                    Case Studies
                  </b-nav-item>


                  <b-nav-item
                    to="/contact-us"
                    :class="{ current: id === 14 }"
                    v-b-toggle.sidebar-no-header
                  >
                    <span>06</span>
                    Contact Us
                  </b-nav-item>

                </b-nav>


                <!-- Related Companies -->

                <div class="sidebarCompanies">

                  <div class="sidebarLabel">
                    OCS GROUP
                  </div>

                  <div class="supportNav_group">

                    <a
                      href="https://ocs-digital.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="supportLogosNav"
                        src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCs_Digital_2023_LogoBLUE_V1-1.png"
                      >
                    </a>


                    <a
                      href="https://ocs-studios.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="supportLogosNav studioesLogo"
                        src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS_Studios_512x512.png"
                      >
                    </a>

                  </div>

                </div>

              </nav>

            </template>

          </b-sidebar>

        </div>


        <!-- OCS Sport Logo -->

        <div class="ocsLogoWrap">

          <b-img
            class="ocsLogo"
            src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/03/OCS__Sport_Logo_2017_WO.png"
          ></b-img>

        </div>

      </div>


      <!-- =========================================
           HERO CONTENT
      ========================================== -->

      <b-container class="heroContainer">

        <b-row class="heroRow">

          <!-- Content -->

          <b-col
            :lg="id === 14 ? 12 : 6"
            md="12"
            class="heroContent"
          >

            <div class="heroContentInner">

              <div class="heroEyebrow">

                <span class="eyebrowLine"></span>

                <span>
                  OCS SPORT
                </span>

              </div>


              <h1>

                <span class="white">
                  {{ acf.acf.splash_title }}
                </span>

                <br />

                <span class="blue">
                  {{ acf.acf.splash_title_1 }}
                </span>

                <br />

                <span class="white">
                  {{ acf.acf.splash_title_2 }}
                </span>

              </h1>


              <!-- Homepage CTA -->

              <template v-if="id === 4">

                <div class="heroCta">

                  <b-button
                    class="splashBtn"
                    to="/tour-management"
                  >
                    Discover Our Technology

                    <span class="arrow">
                      →
                    </span>

                  </b-button>

                </div>

              </template>

            </div>

          </b-col>


          <!-- Supporting image -->

          <b-col
            v-if="id !== 14"
            lg="6"
            md="12"
            class="heroImageColumn"
          >

            <div class="heroImageWrap">

              <div class="imageAccent"></div>

              <b-img
                class="splashSubImg"
                :src="acf.acf.splash_image"
              ></b-img>

            </div>

          </b-col>

        </b-row>

      </b-container>


      <!-- Bottom indicator -->

      <div class="scrollIndicator">

        <span>
          SCROLL TO EXPLORE
        </span>

        <div class="scrollLine"></div>

      </div>

    </b-jumbotron>

  </div>
</template>

<script>
export default {
  name: "Splash",
  props: ["acf", "id"],
};
</script>

<style scoped>

/* =========================================
   HERO
========================================= */

.splash {
  position: relative;

  width: 100%;
  height: 800px;

  margin: 0;
  padding: 0;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  border-radius: 0;

  overflow: hidden;
}

.jumbotron.splash.contactHight {
  height: 300px!important;
}

/* =========================================
   OVERLAY
========================================= */

.heroOverlay {
  position: absolute;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background:
    linear-gradient(
      90deg,
      rgba(4, 20, 31, 0.92) 0%,
      rgba(4, 20, 31, 0.70) 42%,
      rgba(4, 20, 31, 0.25) 75%,
      rgba(4, 20, 31, 0.15) 100%
    );

  z-index: 1;
}


/* =========================================
   TOP BAR
========================================= */

.topBar {
  position: absolute;

  top: 0;
  left: 0;
  right: 0;

  height: 90px;

  z-index: 20;
}


/* =========================================
   LOGO
========================================= */

.ocsLogoWrap {
  position: absolute;

  top: 25px;
  right: 35px;
}

.ocsLogo {
  width: 125px;

  display: block;
}


/* =========================================
   MENU
========================================= */

.menu {
  position: absolute;

  top: 0;
  left: 0;
}

.menuButton {
  width: 70px;
  height: 70px;

  padding: 0;

  border: 0;
  border-radius: 0;

  background: #00aeef;

  color: #ffffff;

  font-size: 25px;

  transition:
    background 0.25s ease,
    width 0.25s ease;
}

.menuButton:hover,
.menuButton:focus {
  background: #003460;

  box-shadow: none;
}


/* =========================================
   HERO CONTENT
========================================= */

.heroContainer {
  position: relative;

  z-index: 5;

  height: 100%;
}

.heroRow {
  height: 100%;

  align-items: center;
}

.heroContent {
  display: flex;

  align-items: center;

  height: 100%;
}

.heroContentInner {
  max-width: 700px;

  padding-top: 40px;
}


/* =========================================
   EYEBROW
========================================= */

.heroEyebrow {
  display: flex;

  align-items: center;

  gap: 12px;

  margin-bottom: 22px;

  color: #00aeef;

  font-size: 11px;
  font-weight: 700;

  letter-spacing: 2px;
}

.eyebrowLine {
  width: 35px;
  height: 3px;

  background: #00aeef;
}


/* =========================================
   TITLE
========================================= */

h1 {
  margin: 0;

  font-size: 72px;

  line-height: 1.08;

  font-weight: 200;

  letter-spacing: -1.5px;
}

.white {
  color: #ffffff;
}

.blue {
  color: #00aeef;

  font-weight: 500;
}


/* =========================================
   CTA
========================================= */

.heroCta {
  margin-top: 45px;
}

.splashBtn {
  display: inline-flex;

  align-items: center;

  gap: 18px;

  padding: 15px 25px;

  border: 0;
  border-radius: 0;

  background: #00aeef;

  color: #ffffff;

  font-size: 13px;
  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 1px;

  transition:
    background 0.25s ease,
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.splashBtn:hover {
  background: #003460;

  transform: translateY(-3px);

  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.20);
}

.arrow {
  font-size: 20px;

  line-height: 1;

  transition: transform 0.25s ease;
}

.splashBtn:hover .arrow {
  transform: translateX(5px);
}


/* =========================================
   HERO IMAGE
========================================= */

.heroImageColumn {
  position: relative;

  z-index: 2;

  display: flex;

  justify-content: center;
  align-items: center;
}

.heroImageWrap {
  position: relative;

  max-width: 570px;

  padding: 25px;
}

.splashSubImg {
  position: relative;

  display: block;

  width: 100%;

  max-height: 500px;

  object-fit: contain;

  z-index: 2;
}


/* =========================================
   IMAGE ACCENT
========================================= */

.imageAccent {
  position: absolute;

  top: 0;
  right: 0;

  width: 65%;

  height: 65%;

  border-top: 3px solid #00aeef;
  border-right: 3px solid #00aeef;

  opacity: 0.7;

  z-index: 1;
}


/* =========================================
   SCROLL INDICATOR
========================================= */

.scrollIndicator {
  position: absolute;

  left: 40px;
  bottom: 35px;

  display: flex;

  align-items: center;

  gap: 15px;

  z-index: 6;
}

.scrollIndicator span {
  color: rgba(255, 255, 255, 0.60);

  font-size: 9px;
  font-weight: 700;

  letter-spacing: 1.7px;
}

.scrollLine {
  width: 55px;
  height: 1px;

  background: #00aeef;
}


/* =========================================
   SIDEBAR
========================================= */

::v-deep .b-sidebar {
  width: 360px;

  background: #ffffff;
}

::v-deep .b-sidebar-body {
  background: #ffffff;
}


/* =========================================
   SIDEBAR HEADER
========================================= */

.sidebarHeader {
  display: flex;

  justify-content: space-between;
  align-items: center;

  height: 95px;

  padding: 20px 25px;

  background: #003460;
}

.sidebarLogo {
  width: 95px;
}

::v-deep .close {
  padding: 5px;

  border: 0;

  background: transparent !important;

  color: #ffffff !important;

  font-size: 35px;

  opacity: 1;
}

::v-deep .close:hover,
::v-deep .close:focus {
  border: 0;

  background: transparent !important;

  box-shadow: none;
}


/* =========================================
   NAVIGATION
========================================= */

.sidebarNavigation {
  padding: 25px 0 35px;
}

::v-deep .sidebarNavigation ul {
  padding: 0;

  margin: 0;

  list-style: none;
}

::v-deep .sidebarNavigation .nav-item {
  margin: 0;
}

::v-deep .sidebarNavigation .nav-link {
  display: flex;

  align-items: center;

  gap: 18px;

  padding: 17px 30px;

  border-left: 4px solid transparent;

  color: #252c32;

  font-size: 14px;
  font-weight: 500;

  text-decoration: none;

  text-transform: uppercase;

  letter-spacing: 0.5px;

  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;
}

::v-deep .sidebarNavigation .nav-link span {
  width: 25px;

  color: #a0a7ac;

  font-size: 9px;
  font-weight: 700;
}

::v-deep .sidebarNavigation .nav-link:hover {
  background: #f3f5f7;

  color: #00aeef;
}

::v-deep .sidebarNavigation .nav-link:hover span {
  color: #00aeef;
}


/* =========================================
   ACTIVE NAV
========================================= */

::v-deep .sidebarNavigation .current .nav-link {
  border-left-color: #00aeef;

  background: #f3f5f7;

  color: #003460;

  font-weight: 700;
}

::v-deep .sidebarNavigation .current .nav-link span {
  color: #00aeef;
}


/* =========================================
   SIDEBAR COMPANIES
========================================= */

.sidebarCompanies {
  margin: 35px 25px 0;

  padding-top: 25px;

  border-top: 1px solid #e5e8ea;
}

.sidebarLabel {
  margin-bottom: 18px;

  color: #8b9399;

  font-size: 9px;
  font-weight: 700;

  letter-spacing: 1.5px;
}

.supportNav_group {
  display: flex;

  align-items: center;

  gap: 20px;
}

.supportLogosNav {
  width: 65px;

  max-height: 65px;

  object-fit: contain;

  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.supportLogosNav:hover {
  opacity: 0.7;

  transform: translateY(-2px);
}

.studioesLogo {
  margin-top: 0;
}


/* =========================================
   992px
========================================= */

@media only screen and (max-width: 992px) {

  .jumbotron.splash.contactHight {
    height: auto!important;
  }

  .splash {
    height: 700px;
  }

  .heroOverlay {
    background:
      linear-gradient(
        90deg,
        rgba(4, 20, 31, 0.90),
        rgba(4, 20, 31, 0.55)
      );
  }

  .heroImageColumn {
    display: none;
  }

  .heroContentInner {
    padding-left: 30px;
  }

  h1 {
    font-size: 62px;
  }

}


/* =========================================
   768px
========================================= */

@media only screen and (max-width: 768px) {

  .splash {
    height: 650px;
  }

  .ocsLogoWrap {
    top: 22px;

    right: 20px;
  }

  .ocsLogo {
    width: 105px;
  }

  .menuButton {
    width: 60px;
    height: 60px;

    font-size: 22px;
  }

  .heroContentInner {
    padding-left: 20px;
    padding-right: 20px;
  }

  h1 {
    font-size: 52px;

    letter-spacing: -1px;
  }

  .heroCta {
    margin-top: 35px;
  }

  .scrollIndicator {
    left: 25px;
    bottom: 25px;
  }

}


/* =========================================
   500px
========================================= */

@media only screen and (max-width: 500px) {

  .splash {
    height: 650px;

    background-position: center;
  }

  .heroOverlay {
    background:
      linear-gradient(
        90deg,
        rgba(4, 20, 31, 0.88),
        rgba(4, 20, 31, 0.68)
      );
  }

  .ocsLogoWrap {
    top: 18px;
    right: 15px;
  }

  .ocsLogo {
    width: 90px;
  }

  .heroEyebrow {
    margin-bottom: 18px;

    font-size: 9px;
  }

  h1 {
    font-size: 30px;

    line-height: 1.1;
    padding-bottom: 30px;
  }

  .splashBtn {
    width: 100%;

    justify-content: center;

    padding: 15px 18px;

    font-size: 11px;
  }

  ::v-deep .b-sidebar {
    width: 320px;
  }

}


/* =========================================
   480px
========================================= */

@media only screen and (max-width: 480px) {

  .splash {
    height: 620px;
  }

  .heroContentInner {
    padding-left: 10px;
    padding-right: 10px;
  }

  h1 {
    font-size: 30px;
    padding-bottom: 30px;
  }

  .scrollIndicator {
    display: none;
  }

}

</style>